import { render, staticRenderFns } from "./subpackage-payment-branch.vue?vue&type=template&id=4bc44afb&scoped=true"
import script from "./subpackage-payment-branch.vue?vue&type=script&lang=js"
export * from "./subpackage-payment-branch.vue?vue&type=script&lang=js"
import style0 from "./subpackage-payment-branch.vue?vue&type=style&index=0&id=4bc44afb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc44afb",
  null
  
)

export default component.exports